module.exports = __webpack_public_path__ + "static/img/product-top-5.7afbcc65.png";